import React from 'react'

import Banner from './Banner'
import Float from './Float'
import Footer from './Footer'
import Header from './Header'
import Main from './Main'

const RootLayout: React.FC = () => {
  return (
    <>
      <Header />
      <Banner />
      <Main />
      <Footer />
      <Float />
    </>
  )
}

export default RootLayout
